export const GET_TASK_PRIORITY = "GET_TASK_PRIORITY"
export const GET_TASK_PRIORITY_SUCCESS = "GET_TASK_PRIORITY_SUCCESS"
export const GET_TASK_PRIORITY_ERROR = "GET_TASK_PRIORITY_ERROR"

export const GET_TASK_PRIORITY_LIST = "GET_TASK_PRIORITY_LIST"
export const GET_TASK_PRIORITY_LIST_SUCCESS = "GET_TASK_PRIORITY_LIST_SUCCESS"
export const GET_TASK_PRIORITY_LIST_ERROR = "GET_TASK_PRIORITY_LIST_ERROR"
  
export const CREATE_TASK_PRIORITY = "CREATE_TASK_PRIORITY"
export const CREATE_TASK_PRIORITY_SUCCESS = "CREATE_TASK_PRIORITY_SUCCESS"
export const CREATE_TASK_PRIORITY_ERROR = "CREATE_TASK_PRIORITY_ERROR"

export const UPDATE_TASK_PRIORITY = "UPDATE_TASK_PRIORITY"
export const UPDATE_TASK_PRIORITY_SUCCESS = "UPDATE_TASK_PRIORITY_SUCCESS"
export const UPDATE_TASK_PRIORITY_ERROR = "UPDATE_TASK_PRIORITY_ERROR"

export const DELETE_TASK_PRIORITY = "DELETE_TASK_PRIORITY"
export const DELETE_TASK_PRIORITY_SUCCESS = "DELETE_TASK_PRIORITY_SUCCESS"
export const DELETE_TASK_PRIORITY_ERROR = "DELETE_TASK_PRIORITY_ERROR"